import { Button, Form, Input, Modal, Steps } from "antd";
import React, { useState } from "react";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import ThirdStep from "./ThirdStep";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import { postApi } from "../../services/apiService/fetchMethod";
import tostMessage from "../../utils/tostMessage";
import FourthStep from "./FourthStep";

function OnboardDevice() {
  const [modalOpen, setModalOpen] = useState(true);
  const [step, setStep] = useState(0);
  const onFinish = async (values) => {
    const url = apiEndPoint().Get_code;
    const { status, data } = await postApi({
      url,
      params: { code: values.deviceCode },
    });
    console.log(data);
    if (status === 200) {
      setModalOpen(false);
      localStorage.setItem('code',data?.data?.code)
    }else{
      tostMessage(400,"Code is invaild!!")
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  if (modalOpen) {
    return (
      <>
        <Modal centered open={modalOpen} footer={null} closable={false}>
          <Form
            name="basic"
            style={{
              marginTop: "1rem",
              maxWidth: 600,
            }}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Enter Device Code"
              name="deviceCode"
              rules={[
                {
                  required: true,
                  message: "Please input your code!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  }
  return (
    <div style={{ padding: "3rem" }}>
      <Steps
        size="small"
        current={step}
        items={[
          {
            title: "Onboard Project",
          },
          {
            title: "Onboard User",
          },
          {
            title: "Onboard Site",
          },
          {
            title: "Onboard Device",
          },
        ]}
      />
      {step === 0 ? (
        <FirstStep setStep={setStep} />
      ) : step === 1 ? (
        <SecondStep setStep={setStep} />
      ) :  step === 2 ?(
        <ThirdStep setStep={setStep} />
      ):<FourthStep setStep={setStep} />}
    </div>
  );
}

export default OnboardDevice;
